import { styled, css, Box, BoxProps } from '@mui/material'
import { PriceStylesProps } from './Price.types'
import { getFlexValue, getUnitValue } from '../../../utils/processStyles'
import Icon from '../Icon'
import Text from '../Text'

const noForwardProps = ['inline', 'wrapContent', 'vertical']

export const PriceWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => !noForwardProps.includes(prop)
})<PriceStylesProps & BoxProps>(
  ({ inline, size, vertical, align, gap, wrapContent }) => css`
    display: ${inline ? 'inline-flex' : 'flex'};
    vertical-align: middle;
    flex-wrap: ${wrapContent ? 'nowrap' : 'wrap'};
    justify-content: ${getFlexValue(align)};
    align-items: flex-start;
    font-size: ${getUnitValue(size)};
    text-align: ${align};
    line-height: 1em;
    gap: ${getUnitValue(gap)};
    > * {
      justify-content: ${getFlexValue(align)};
      width: ${vertical ? '100%' : 'auto'};
    }
  `
)
PriceWrapper.defaultProps = {
  size: '14px',
  fontWeight: 'bold',
  align: 'inherit',
  gap: 6
}

export const IconWrapper = styled(Icon)(
  () => css`
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.25em;
  `
)

export const PriceLabel = styled(Text)<PriceStylesProps>(
  () => css`
    display: inline-block;
    white-space: nowrap;
    font-weight: inherit;
    line-height: inherit;
    vertical-align: middle;
  `
)
PriceLabel.defaultProps = {
  color: 'primary'
}

export const DiscountLabel = styled(PriceLabel)(
  () => css`
    opacity: 0.8;
    text-decoration: line-through;
    line-height: inherit;
    font-weight: normal;
  `
)
DiscountLabel.defaultProps = {
  paragraph: false,
  color: 'text.secondary'
}

export const UnitPriceLabel = styled(DiscountLabel, {
  shouldForwardProp: (prop) => !['inline'].includes(String(prop))
})(
  () => css`
    text-decoration: none;
    line-height: inherit;
  `
)

export const FeeLabel = styled(UnitPriceLabel, {
  shouldForwardProp: (prop) => !['inline'].includes(String(prop))
})(
  () => css`
    display: block;
    margin-top: 0.25em;
    text-decoration: none;
    line-height: inherit;
  `
)
FeeLabel.defaultProps = {
  component: 'span'
}
